import moment from "moment";
import { CalendarBlockedDateType } from "../../../../types";

export const getCustomBlockedCalendarDates = (
  evalMethod: string | undefined,
): CalendarBlockedDateType[] => {
  let blockedDateRanges = [];
  switch (evalMethod) {
    case "GLFiscalCurrentFYYearEnabled":
      blockedDateRanges = [
        {
          startDate: moment("0001-01-01T00:00:00.000"), //all previous dates
          endDate: moment().startOf("day").subtract(1, "days"), // till current day
        },
        {
          startDate: moment().add(1, "year").startOf("year"),
          endDate: moment("9999-12-31T23:59:59.999Z"), //all future dates
        },
      ];
      return blockedDateRanges;

    case "GLFiscalnextActiveMonthEnabled":
      blockedDateRanges = [
        {
          startDate: moment("0001-01-01T00:00:00.000"), //all previous dates
          endDate: moment().startOf("day").subtract(1, "days"), // till current day
        },
      ];

      return blockedDateRanges;

    default:
      return [];
  }
};
